__turbopack_context__.v({
  "body": "reviews-module-scss-module__F5WP8W__body",
  "body-wrapper": "reviews-module-scss-module__F5WP8W__body-wrapper",
  "card-content": "reviews-module-scss-module__F5WP8W__card-content",
  "card-footer": "reviews-module-scss-module__F5WP8W__card-footer",
  "card-top": "reviews-module-scss-module__F5WP8W__card-top",
  "carousel-slide": "reviews-module-scss-module__F5WP8W__carousel-slide",
  "course-name": "reviews-module-scss-module__F5WP8W__course-name",
  "dot": "reviews-module-scss-module__F5WP8W__dot",
  "dot--active": "reviews-module-scss-module__F5WP8W__dot--active",
  "dots": "reviews-module-scss-module__F5WP8W__dots",
  "error": "reviews-module-scss-module__F5WP8W__error",
  "header-row": "reviews-module-scss-module__F5WP8W__header-row",
  "heading": "reviews-module-scss-module__F5WP8W__heading",
  "loader": "reviews-module-scss-module__F5WP8W__loader",
  "meta-row": "reviews-module-scss-module__F5WP8W__meta-row",
  "mobile-card-wrapper": "reviews-module-scss-module__F5WP8W__mobile-card-wrapper",
  "mobile-track": "reviews-module-scss-module__F5WP8W__mobile-track",
  "modal-body": "reviews-module-scss-module__F5WP8W__modal-body",
  "modal-content": "reviews-module-scss-module__F5WP8W__modal-content",
  "modal-main": "reviews-module-scss-module__F5WP8W__modal-main",
  "modal-reviewer": "reviews-module-scss-module__F5WP8W__modal-reviewer",
  "pager": "reviews-module-scss-module__F5WP8W__pager",
  "pager-slot": "reviews-module-scss-module__F5WP8W__pager-slot",
  "quote-icon": "reviews-module-scss-module__F5WP8W__quote-icon",
  "rating": "reviews-module-scss-module__F5WP8W__rating",
  "rating-tag": "reviews-module-scss-module__F5WP8W__rating-tag",
  "review-card": "reviews-module-scss-module__F5WP8W__review-card",
  "reviewer": "reviews-module-scss-module__F5WP8W__reviewer",
  "reviews": "reviews-module-scss-module__F5WP8W__reviews",
  "reviews-carousel": "reviews-module-scss-module__F5WP8W__reviews-carousel",
  "reviews-slide-layout": "reviews-module-scss-module__F5WP8W__reviews-slide-layout",
  "show-link": "reviews-module-scss-module__F5WP8W__show-link",
  "star-icon": "reviews-module-scss-module__F5WP8W__star-icon",
  "time-ago": "reviews-module-scss-module__F5WP8W__time-ago",
});
